<div class="d-flex" [ngClass]="customClass">
  <ng-container [ngSwitch]="getFormat(data.format)">
    <ng-container *ngSwitchCase="formats.PERCENTAGE">
      <gtd-crm-percent [data]="data[field]"></gtd-crm-percent>
    </ng-container>
    <ng-container *ngSwitchCase="formats.FLOAT">
      {{ data[field] | numberFormat : true }}
    </ng-container>
    <ng-container *ngSwitchCase="formats.MONEY">
      <gtd-ui-field-crm-currency [data]="data[field]" [currencyCode]="currencyCode"></gtd-ui-field-crm-currency>
    </ng-container>
    <ng-container *ngSwitchCase="formats.BOOLEAN">
      {{ data[field] ? 'True' : 'False' }}
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{ data[field] | numberFormat }}
    </ng-container>
  </ng-container>
</div>
